import React from "react";
import "../styles/bonificaciones.css";

const currency = new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD" });

const EstadoChip = ({ estado }) => {
  if (!estado) return <span className="badge bg-light text-dark">Sin estado</span>;
  const map = {
    pendiente: "warning",
    pagada: "success",
    no_pagada: "danger",
    anulada: "secondary",
  };
  const color = map[estado] || "secondary";
  return <span className={`badge bg-${color} text-uppercase`}>{estado}</span>;
};

export default function BonificacionesTable({ bonificaciones = [], loading, error, onSelect, seleccionadoId }) {
  return (
    <div className="management-card bonificaciones-table h-100 d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <p className="management-eyebrow mb-1">Listado</p>
          <h6 className="mb-0">Bonificaciones pendientes</h6>
        </div>
        {loading && (
          <div className="text-muted small">
            <i className="bi bi-arrow-repeat me-2 spin" />
            Cargando...
          </div>
        )}
      </div>

      {error && <div className="alert alert-danger">Error: {error}</div>}

      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Referente</th>
              <th>Referido</th>
              <th>Monto</th>
              <th>Estado</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            {bonificaciones.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center text-muted py-4">
                  {loading ? "Cargando..." : "Sin bonificaciones con los filtros actuales."}
                </td>
              </tr>
            )}
            {bonificaciones.map((bonificacion, idx) => {
              const displayIndex = bonificaciones.length - idx;
              return (
              <tr
                key={bonificacion.id}
                className={seleccionadoId === bonificacion.id ? "table-active" : ""}
                role="button"
                onClick={() => onSelect?.(bonificacion)}
              >
                <td>#{displayIndex}</td>
                <td>{bonificacion.referente || "No asignado"}</td>
                <td>{bonificacion.referido || "No disponible"}</td>
                <td>
                  {bonificacion.montoNeto != null ? (
                    <div className="d-flex flex-column">
                      <span className="text-muted text-decoration-line-through small">
                        {currency.format(bonificacion.monto)}
                      </span>
                      <span className="text-success fw-semibold">
                        {currency.format(bonificacion.montoNeto)}
                      </span>
                    </div>
                  ) : (
                    currency.format(bonificacion.monto || 0)
                  )}
                </td>
                <td>
                  <EstadoChip estado={bonificacion.estado} />
                </td>
                <td>
                  {bonificacion.fechaGeneracion
                    ? new Date(bonificacion.fechaGeneracion).toLocaleString()
                    : "-"}
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
